// eslint-disable-next-line import/no-unresolved
import auth from '@/middleware/auth'

const formTable = [
  // CREATIONS
  {
    path: '/suplementos-hotels/list',
    name: 'suplementos-hotels-list',
    // eslint-disable-next-line import/no-unresolved
    component: () => import('@/views/nomencladores/hotels/Suplementos.vue'),
    meta: {
      layout: 'content',
      middleware: auth,
      pertenece: 'nom_suplemento_contrate_hotels',
    },
  },
]

export default formTable
